import { render, staticRenderFns } from "./TeacherUnsubmitedStudent.vue?vue&type=template&id=868ff384&scoped=true"
import script from "./TeacherUnsubmitedStudent.vue?vue&type=script&lang=js"
export * from "./TeacherUnsubmitedStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868ff384",
  null
  
)

export default component.exports